<template>
	<div class="SiteMonitoring">
		<el-row type="flex" justify="space-between" align="top">
			<div>
				<el-button type="primary" @click="addSiteMonitoring('addRecord')"
					>新增</el-button
				>
			</div>

			<el-form inline :model="formScreen" ref="formScreen">
        <el-form-item prop="status">
          <el-select v-model="formScreen.status" placeholder="选择监听状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
				<el-form-item prop="keyWord">
					<el-input
						v-model="formScreen.keyWord"
						placeholder="关键词搜索"
						style="width:400px"
					></el-input>
				</el-form-item>
				<el-form-item size="large">
					<el-button type="primary" @click="getTableList()"
						>搜索</el-button
					>
					<el-button type="primary" @click="reset('formScreen')"
						>重置</el-button
					>
				</el-form-item>
			</el-form>
		</el-row>
		<el-table
			:data="listTable"
			border
			style="width: 100%"
			:cell-style="{ textAlign: 'center' }"
			:header-cell-style="{ textAlign: 'center' }"
		>
			<el-table-column
				prop="monitorName"
				label="监听名称"
			></el-table-column>
			<el-table-column
				prop="shopWebsite"
				label="监听站点"
			></el-table-column>
			<el-table-column
				prop="scriptPath"
				label="监听服务"
			></el-table-column>
			<el-table-column
				prop="shopMonitorStatus"
				label="店铺监听状态"
			>
        <template slot-scope="scope">
          <el-tag v-if="scope.row.shopMonitorStatus === 1" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.shopMonitorStatus === 0" type="danger">异常</el-tag>
        </template>
      </el-table-column>
			<el-table-column
				prop="paypalMonitorStatus"
				label="支付监听状态"
			>
        <template slot-scope="scope">
          <el-tag v-if="scope.row.paypalMonitorStatus === 1" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.paypalMonitorStatus === 0" type="danger">异常</el-tag>
        </template>
      </el-table-column>
			<el-table-column
				prop="status"
				label="监听状态"
			>
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-text="启用"
            inactive-text="停用"
            :active-value="1"
            :inactive-value="0"
            @change="updateStatus(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
			<el-table-column prop="date" label="操作" width="200">
				<template slot-scope="scope">
					<!-- <el-button type="primary" @click="addSiteMonitoring(scope.row)">监听历史</el-button> -->
					<el-button type="primary" @click="editSiteMonitoring(scope.row)">编辑</el-button>
					<el-button type="danger" @click="delSiteMonitoring(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page"
				:page-sizes="[20, 50, 100, 200, 300]"
				:page-size="size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
    </div>
		<!-- 新增/冻结记录 -->
		<el-dialog
			top="160px"
			:title="addsiteTitle"
			:visible.sync="addsiteDialog"
			width="30%"
		>
			<el-form
				class="custom-dialog"
				:model="formData"
				ref="formData"
				label-width="96px"
				:rules="formRules"
			>
        <el-form-item label="监听名称" prop="monitorName">
          <el-input v-model="formData.monitorName"></el-input>
        </el-form-item>

        <el-form-item label="监听地址" prop="shopWebsite">
          <el-input v-model="formData.shopWebsite"></el-input>
        </el-form-item>

        <el-form-item label="监听服务" prop="scriptPath">
					<el-select v-model="formData.scriptPath" style="width: 100%">
						<el-option v-for="item in scriptOptions"
							:key="item.id"
							:label="item.remark"
							:value="item.host">
						</el-option>
					</el-select>
        </el-form-item>

        <el-form-item label="监听时间段" prop="timer">
          <el-date-picker
            v-model="formData.timer"
            type="datetimerange"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss"
            @change="changeTimer">
          </el-date-picker>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <el-form-item label="监听间隔" prop="intervalTime">
              <el-input-number size="small" v-model="formData.intervalTime" :min="10" :max="60">
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <el-form-item label="联系电话" prop="contactNumber">
              <el-input v-model="formData.contactNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="启用状态" prop="status">
          <el-switch
            v-model="formData.status"
            active-text="启用"
            inactive-text="停用"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addsiteDialog = false">取 消</el-button>
				<el-button type="primary" @click="submit('formData')" :loading="loading">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, ajaxGet, Baseurl } from '@/api/api/api'
import {
	validateMobiePhone,
} from '../../utils/validate'
export default {
	data() {
    var validateMobile = (rule, value, callback) => {
			if (!validateMobiePhone(value)) {
				callback(new Error('手机号格式错误'))
			} else {
				callback()
			}
		}
		return {
      addsiteTitle: '新增监听',
			addsiteDialog: false,
			UserInfo: {},
			loading: false,
			formScreen: {
				keyWord: ''
			},
			formData: {
        monitorName: '',
        shopWebsite: '',
        timer: '',
        intervalTime: 10,
        contactNumber: '',
				status: 1,
        startTime: '',
        endTime: '',
        createBy: ''
			},
			formRules: {
        monitorName: [
          {
            required: true,
						message: '监听名称不能为空',
						trigger: 'blur',
          }
        ],
        shopWebsite: [
          {
            required: true,
						message: '监听地址不能为空',
						trigger: 'blur',
          }
        ],
        scriptPath: [
          {
            required: true,
						message: '监听服务不能为空',
						trigger: 'blur',
          }
        ],
        timer: [
          {
            required: true,
						message: '监听时间段不能为空',
						trigger: 'change',
          }
        ],
        intervalTime: [
          {
            required: true,
						message: '监听地址不能为空',
						trigger: 'change',
          }
        ],
        contactNumber: [
					{
						required: true,
						message: '手机号不能为空',
						trigger: 'blur',
					},
					{ validator: validateMobile, trigger: 'blur' },
				],
        status: [
					{
						required: true,
						message: '启用状态不能为空',
						trigger: 'blur',
					}
				]
			},
			listTable: [],
			page: 1,
			size: 20,
			total: 0,
			scriptOptions: []
		}
	},
	created() {
		this.UserInfo = JSON.parse(localStorage.getItem('role'))
    this.formData.createBy = this.UserInfo.rid
    this.formData.companyId = this.UserInfo.company_id
		this.getTableList()
		this.getScriptOptions()
	},
  watch: {
    addsiteDialog(val) {
      if (!val) {
        this.formData = {
          monitorName: '',
          shopWebsite: '',
          timer: '',
          intervalTime: 10,
          contactNumber: '',
          status: 1,
          startTime: '',
          endTime: '',
          createBy: this.UserInfo.rid,
          companyId: this.UserInfo.company_id
        }
      }
    }
  },
	methods: {
		getTableList() {
			const API = Baseurl + '/monitor/page'
			const paramsData = {
				page: this.page,
				pageSize: this.size,
				keyWord: this.formScreen.keyWord,
				status: this.formScreen.status,
				companyId: this.UserInfo.company_id,
				rid: this.UserInfo.rid,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 1) {
					this.listTable = data.records
					this.total = data.total
				}
			})
		},
		reset(formName) {
			this.$refs[formName].resetFields()
			this.getTableList()
		},
		getScriptOptions() {
			ajaxGet(Baseurl + '/monitor/serverList').then((res) => {
				const { code, data } = res.data
				if (code === 1) {
					this.scriptOptions = data
				}
			})
		},
    changeTimer() {
      this.formData.startTime = this.formData.timer[0]
      this.formData.endTime = this.formData.timer[1]
    },
		handleSizeChange(event) {
			this.size = event
			this.getTableList()
		},
		handleCurrentChange(event) {
			this.page = event
			this.getTableList()
		},
		addSiteMonitoring() {
			this.addsiteDialog = true
		},
    editSiteMonitoring(row) {
      this.$set(row, 'timer', [row.startTime, row.endTime])
      this.formData = JSON.parse(JSON.stringify(row))
      this.addsiteDialog = true
    },
    delSiteMonitoring(id) {
      this.$confirm('确认删除此条数据？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					ajaxGet(Baseurl + 'monitor/delete/'+id).then((res) => {
						if (res.data.code == 1) {
							this.$message({
								type: 'success',
								message: '删除成功!',
							})
							this.getTableList()
						} else {
							this.$message.error('删除失败')
						}
					})
          .catch(() => {
            this.$message.error('删除失败')
          })
				})
    },
    updateStatus(row) {
      console.log(row);
      const API = Baseurl + '/monitor/update'
      ajaxPost(API, {id: row.id, status: row.status}).then((res) => {
        const { code } = res.data
        if (code === 1) {
          this.$message.success('操作成功')
          this.getTableList()
        } else {
          this.$message.error(res.data)
        }
      }).catch(() => {
        this.$message.error('操作失败')
      })
    },
    submit(form) {
      this.$refs[form].validate((valid) => {
				if (valid) {
          if (this.formData.id) {
            const API = Baseurl + '/monitor/update'
            this.loading = true
            ajaxPost(API, this.formData).then((res) => {
              this.loading = false
              const { code } = res.data
              if (code === 1) {
                this.$message.success('编辑成功')
                this.getTableList()
                this.addsiteDialog = false
              } else {
                this.$message.error(res.data)
              }
            }).catch(() => {
              this.$message.error('服务器出错，请联系客服解决。')
              this.loading = false
            })
          } else {
            const API = Baseurl + '/monitor/add'
            this.loading = true
            ajaxPost(API, this.formData).then((res) => {
              this.loading = false
              const { code } = res.data
              if (code === 1) {
                this.$message.success('添加成功')
                this.getTableList()
                this.addsiteDialog = false
              } else {
                this.$message.error(res.data)
              }
            }).catch(() => {
              this.$message.error('服务器出错，请联系客服解决。')
              this.loading = false
            })
          }
				}
			})
    }
	}
}
</script>

<style lang="scss" scoped>
.SiteMonitoring {
	width: 98%;
  padding-bottom: 55px;
  .page {
		position: fixed;
		width: 100%;
		bottom: 0;
		background-color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 50px;
		z-index: 99;
	}
  /deep/ .el-range-editor--small.el-input__inner {
    width: 100%;
  }
	.custom-dialog {
		padding: 0 20px;
		.width380 {
			width: 380px;
		}
	}
	.scope_img {
		width: 55px;
		height: 55px;
		margin: 0 auto;
		img {
			width: 100%;
			height: 100%;
		}
	}
}
.prduct_img {
	width: 500px;
	height: 500px;
}
</style>
